export default {
  BACKGROUND: -1,
  DEFAULT: 0,
  FOREGROUND: 1,
  NAV: 11,
  MODAL: 30,
};
